import { FC, PropsWithChildren, ReactNode, useId } from 'react';

import { RadioCard } from '@eneco/sparky';

import { Price as PriceType } from '../../../../shared/types';
import { ProductCardContent, ProductCardFrame } from '../../../components/ProductCard/ProductCardContent';

interface Props {
  id: string;
  title?: string;
  subtitle?: string;
  ribbon?: ReactNode;
  touRibbon?: ReactNode;

  /** Headline price the customer effectively pays per month, including any discount. */
  price?: PriceType;
  /** Optional undiscounted monthly term amount ("Termijnbedrag"), shown next to the headline. */
  secondaryPrice?: PriceType;

  usps?: string[];
}

/**
 * Experiment exp-n-575 product card: a radio card around {@link ProductCardContent}.
 * Title, subtitle, dual price and USPs come from that shared content.
 */
export const ProductCard: FC<PropsWithChildren<Props>> = ({
  id: productId,
  title,
  subtitle,
  ribbon,
  touRibbon,
  price,
  secondaryPrice,
  usps,
  children,
}) => {
  const id = useId();

  return (
    <ProductCardFrame ribbon={ribbon} touRibbon={touRibbon}>
      <RadioCard value={productId} ariaLabelledby={`${id}-label ${id}-price`}>
        <ProductCardContent
          id={id}
          title={title}
          subtitle={subtitle}
          price={price}
          secondaryPrice={secondaryPrice}
          usps={usps}
          titleSuffix={<RadioCard.Indicator />}>
          {children}
        </ProductCardContent>
      </RadioCard>
    </ProductCardFrame>
  );
};
